import type { MobilisationEvent } from '@hcc/types';
import { TasksPanel } from '../../../components/person/TasksPanel';
import { ApplyTemplatePanel } from '../../../components/person/ApplyTemplatePanel';
import { OnboardingVisibilityPanel } from '../../../components/person/OnboardingVisibilityPanel';
import { OnboardingChecklistCard } from '../../../components/onboarding/OnboardingChecklistCard';
import { PersonDocumentsPanel } from '../../../components/onboarding/PersonDocumentsPanel';
import { PersonFormsPanel } from '../../../components/onboarding/PersonFormsPanel';
import { PersonTrainingPanel } from '../../../components/onboarding/PersonTrainingPanel';
import { PersonCatalogTasksPanel } from '../../../components/onboarding/PersonCatalogTasksPanel';
import type { PersonApi } from './types';

export function OnboardingTab({
  person,
  metadata,
  events,
  refreshEvents,
}: {
  person: PersonApi;
  metadata: Record<string, unknown>;
  events: MobilisationEvent[] | null;
  refreshEvents: () => void;
}) {
  return (
    <>
      <TasksPanel personId={person.id} events={events} onChange={refreshEvents} />
      <OnboardingChecklistCard personId={person.id} />
      <ApplyTemplatePanel personId={person.id} position={person.position} />
      <OnboardingVisibilityPanel
        personId={person.id}
        hidden={metadata.onboarding_hidden === true}
      />
      <PersonDocumentsPanel personId={person.id} />
      <PersonFormsPanel personId={person.id} />
      <PersonTrainingPanel
        personId={person.id}
        excludedFromEveryone={metadata.training_assign_all_excluded === true}
      />
      <PersonCatalogTasksPanel personId={person.id} />
    </>
  );
}
